import React, { createContext, useContext, useState } from 'react';

const ShelfTabContext = createContext();

// eslint-disable-next-line react-refresh/only-export-components
export const useShelfTab = () => {
  const context = useContext(ShelfTabContext);
  if (!context) throw new Error('useShelfTab must be used within ShelfTabProvider');
  return context;
};

export const ShelfTabProvider = ({ children }) => {
  const [activeTab, setActiveTab] = useState('shelf');

  return (
    <ShelfTabContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </ShelfTabContext.Provider>
  );
};

export default ShelfTabContext;